import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { testUrl } from "../BaseData";

const DepartmentActivityDetail = () => {
    const { id } = useParams();
    const { t, i18n } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const currentLang = i18n.language;

    useEffect(() => {
        setLoading(true);
        setError(null);
        axios.get(testUrl + "/api/activity-post-detail/" + id)
            .then((response) => {
                setData(response.data.activity);
            })
            .catch((err) => {
                console.error(err);
                setError("Ma'lumotlarni yuklashda xatolik");
            })
            .finally(() => setLoading(false));
    }, [id, currentLang]);

    if (loading) return <div style={{ textAlign: 'center', padding: '100px' }}>Yuklanmoqda...</div>;
    if (error) return <div style={{ textAlign: 'center', padding: '100px' }}>{error}</div>;
    if (!data) return <div style={{ textAlign: 'center', padding: '100px' }}>Maqola topilmadi</div>;

    return (
        <div style={{
            maxWidth: '1200px',
            margin: '40px auto',
            padding: '40px',
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
        }}>
            <h1 style={{
                fontSize: '30px',
                color: '#2f3e46',
                marginBottom: '20px',
                fontWeight: 'bold',
                textAlign: 'left',
                wordBreak: 'break-word'
            }}>
                {data[`name_${currentLang}`]}
            </h1>

            <div
                style={{
                    fontSize: '16px',
                    color: '#555555',
                    lineHeight: '1.8',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                }}
                dangerouslySetInnerHTML={{ __html: data[`content_${currentLang}`] }}
            />
        </div>
    );
};

export default DepartmentActivityDetail;
